module.exports = __webpack_public_path__ + "img/lable_books_jp.4904e2c4.svg";